import React from "react";

export const Container = (props) => {
  const { children } = props;
  return <div className="container-new-home" style={{margin:"-90px auto 0"}}>{children}</div>;
};
